var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"projects-list-item",style:({
		backgroundImage: ("url(" + _vm.backgroundImage + ")"),
		borderColor: _vm.borderColor
	}),attrs:{"title":_vm.project.title},on:{"click":_vm.onClick}},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.project.title)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }